import React, { useContext, useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';

import { useNavigate, useParams } from 'react-router-dom';

import { GetCompany, PostCompanyBusinessDetails } from '../services/httpServices';

import { styled } from '@mui/material/styles';
// import { TextField } from '@material-ui/core';
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));
const BusinessDetails = (props) => {
  const navigate = useNavigate();
  let { id } = useParams();
  const [roles, setRoles] = useState([]);

  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [value, setValue] = useState('female');
  const [company, setCompany] = useState({});
  const [companyLayOff, setCompanyLayOff] = useState(false);
  const [layOffCurrentApplied, setLayOffCurrentApplied] = useState(false);
  const [workingHours, setWorkingHours] = useState('');
  const [banifitPlan, setBanifitPlan] = useState('No');
  const [vacationPay, setVacationPay] = useState('No');
  const [receiveSupport, setReceiveSupport] = useState(false);
  const totalEmployeesRef = useRef('');
  const totalNumberOfEmpRef = useRef('');
  const totalNumberOfCandRef = useRef('');
  const totalNumberOfTfwRef = useRef('');
  const partTimeRef = useRef('');
  const numOfCanditateRef = useRef('');
  const departmentRef = useRef('');
  const foreignWoekerRef = useRef('');
  const reasonRef = useRef('');
  const numOfCandidateCurrentlyAppRef = useRef('');
  const fwCurrentlyAppRef = useRef('');
  const reasonCurrentlyAppRef = useRef('');
  const banifitPlanRef = useRef('');
  const currentlyEmployedRef = useRef('');
  const programRef = useRef('');

  const fetchCompany = async (event) => {
    const company = await GetCompany(id);
    // setBusinessType(company.businessInformations[0].businessType);
    setCompanyLayOff(company.businessDetails[0]?.companyLayOff == 'true' ? true : false);
    setLayOffCurrentApplied(company.businessDetails[0]?.layOffCurrentApplied == 'true' ? true : false);
    setReceiveSupport(company.businessDetails[0]?.receiveSupport == 'true' ? true : false);
    setBanifitPlan(company.businessDetails[0].employeeBenefit);
    setWorkingHours(company.businessDetails[0].workingHours);
    setVacationPay(company.businessDetails[0].vacationPay);
    // setIsCorporateHeadOffice(company.businessInformations[0].temporaryWorker);
    // setLmiaRevoked(company.companyInformations[0].lmiarevoked == 'true' ? true : false);
    setCompany(company);
    setLoading(false);
  };
  useEffect(() => {
    fetchCompany();
  }, []);
  // #endregion Refs

  //   const handleClose = () => {
  //     setOpen(false);
  //   };

  const SaveUser = async (event) => {
    setLoading(true);
    event.preventDefault();
    //console.log('saveHit');
    const payload = {
      totalEmployees: totalEmployeesRef.current.value,
      currentEmployees: totalNumberOfEmpRef.current.value,
      totalNumOfCanadians: totalNumberOfCandRef.current.value,
      temporaryEmployees: totalNumberOfTfwRef.current.value,
      partTimeEmployees: partTimeRef.current.value,
      companyLayOff: companyLayOff,
      department: departmentRef.current.value,
      foreignWorkersOff: foreignWoekerRef.current.value,
      reason: reasonRef.current.value,
      benefitPlans: banifitPlan,
      vacationPay: vacationPay,
      receiveSupport: receiveSupport,
      numOfCanadiansLayOff: numOfCandidateCurrentlyAppRef.current.value,
      fwCurrentlyApp: fwCurrentlyAppRef.current.value,
      reasonCurrentlyApp: reasonCurrentlyAppRef.current.value,
      employeeBenefit: banifitPlan,
      benefitPlans: banifitPlanRef.current.value,
      canadiansLayOff: numOfCanditateRef.current.value,
      totalEmployeesThisOccupation: currentlyEmployedRef.current.value,
      governmentOfCanadaProgram: programRef.current.value,

      layOffCurrentApplied: layOffCurrentApplied,
      workingHours: workingHours,
    };

    //console.log(payload);
    let response = await PostCompanyBusinessDetails(id, payload);
    //console.log('PostResponse:', response);

    if (response.status == 200) {
      setLoading(false);
      props.setMessage("Company's Business Details saved successfully.");
      props.setSaved(true);
      props.setOpen(true);
      let companySaved = company;
      companySaved.businessDetails[0] = response.data;
      setCompany(companySaved);
      //console.log('Id:', id);
      // setTimeout(() => {
      //   navigate(`/app/EditCompany/${id}`);
      // }, 2000);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      // setPosting(false);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleChangeCompanyLayOff = (event) => {
    event.target.value == 'true' ? setCompanyLayOff(true) : setCompanyLayOff(false);
    if (event.target.value == 'true') {
      numOfCanditateRef.current.value = company.businessDetails[0]?.canadiansLayOff;
      departmentRef.current.value = company.businessDetails[0]?.department;
      foreignWoekerRef.current.value = company.businessDetails[0]?.foreignWorkersOff;
      reasonRef.current.value = company.businessDetails[0]?.reason;
    } else {
      numOfCanditateRef.current.value = '';
      departmentRef.current.value = '';
      foreignWoekerRef.current.value = '';
      reasonRef.current.value = '';
    }
  };
  const handleChangeLayOffCurrentApplied = (event) => {
    event.target.value == 'true' ? setLayOffCurrentApplied(true) : setLayOffCurrentApplied(false);
    if (event.target.value == 'true') {
      numOfCandidateCurrentlyAppRef.current.value = company.businessDetails[0]?.numOfCanadiansLayOff;
      fwCurrentlyAppRef.current.value = company.businessDetails[0]?.fwCurrentlyApp;
      reasonCurrentlyAppRef.current.value = company.businessDetails[0]?.reasonCurrentlyApp;
    } else {
      numOfCandidateCurrentlyAppRef.current.value = '';
      fwCurrentlyAppRef.current.value = '';
      reasonCurrentlyAppRef.current.value = '';
    }
  };

  const handleChangeBenifitPlan = (event) => {
    setBanifitPlan(event.target.value);
    //console.log('MyValue:', event.target.value);
    //console.log('MyValue0:', company.businessDetails[0]?.benefitPlans);

    if (event.target.value == 'Yes') {
      banifitPlanRef.current.value = company.businessDetails[0]?.benefitPlans;
    } else {
      banifitPlanRef.current.value = '';
    }
  };
  const handleChangeWorkingHours = (event) => {
    setWorkingHours(event.target.value);
  };
  const handleChangeReceiveSupport = (event) => {
    event.target.value == 'true' ? setReceiveSupport(true) : setReceiveSupport(false);
    if (event.target.value == 'true') {
      programRef.current.value = company.businessDetails[0]?.governmentOfCanadaProgram;
    } else {
      programRef.current.value = '';
    }
  };
  const handleChangeVacationPay = (event) => {
    setVacationPay(event.target.value);
  };

  return (
    <>
      <form onSubmit={SaveUser}>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box component={Paper} p={1}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Total Employees"
                      variant="outlined"
                      fullWidth
                      type="number"
                      size="small"
                      defaultValue={company.businessDetails[0]?.totalEmployees}
                      inputRef={totalEmployeesRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Total number of current employees"
                      variant="outlined"
                      fullWidth
                      type="number"
                      size="small"
                      defaultValue={company.businessDetails[0]?.currentEmployees}
                      inputRef={totalNumberOfEmpRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Total number of Canadians/PR"
                      variant="outlined"
                      fullWidth
                      type="number"
                      size="small"
                      defaultValue={company.businessDetails[0]?.totalNumOfCanadians}
                      inputRef={totalNumberOfCandRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Total Number of Temporary Foreign workers"
                      variant="outlined"
                      fullWidth
                      type="number"
                      size="small"
                      defaultValue={company.businessDetails[0]?.temporaryEmployees}
                      inputRef={totalNumberOfTfwRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Employees currently employed in this occupation"
                      type="number"
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={company.businessDetails[0]?.totalEmployeesThisOccupation}
                      inputRef={currentlyEmployedRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Part time employees"
                      type="number"
                      variant="outlined"
                      fullWidth
                      size="small"
                      inputRef={partTimeRef}
                    />
                  </Grid>
                  <Grid spacing={2} item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        Did your company Lay-Off any workers within the last 12 months?
                      </FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={companyLayOff}
                        onChange={handleChangeCompanyLayOff}
                      >
                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                        <FormControlLabel value="false" control={<Radio />} label="No" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid direction="column" spacing={2} item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">If yes Please indicate following:</FormLabel>
                    </FormControl>
                    <Item>
                      <TextField
                        label="Number of Canadians"
                        type="number"
                        variant="outlined"
                        fullWidth
                        size="small"
                        required
                        defaultValue={company.businessDetails[0]?.canadiansLayOff}
                        disabled={!companyLayOff}
                        inputRef={numOfCanditateRef}
                      />
                    </Item>
                    <Item>
                      <TextField
                        label="Foreign Workers"
                        type="number"
                        variant="outlined"
                        fullWidth
                        size="small"
                        required
                        disabled={!companyLayOff}
                        defaultValue={company.businessDetails[0]?.foreignWorkersOff}
                        inputRef={foreignWoekerRef}
                      />
                    </Item>
                  </Grid>
                  <Grid direction="column" spacing={2} item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group"></FormLabel>
                    </FormControl>
                    <Item>
                      <TextField
                        label="Department"
                        variant="outlined"
                        fullWidth
                        disabled={!companyLayOff}
                        size="small"
                        required
                        defaultValue={company.businessDetails[0]?.department}
                        inputRef={departmentRef}
                      />
                    </Item>
                    <Item>
                      <TextField
                        label="Reason"
                        variant="outlined"
                        fullWidth
                        disabled={!companyLayOff}
                        defaultValue={company.businessDetails[0]?.reason}
                        size="small"
                        required
                        inputRef={reasonRef}
                      />
                    </Item>
                  </Grid>
                  <Grid spacing={2} item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        Did your company lay-off any workers from the position we are currently applying for?
                      </FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={layOffCurrentApplied}
                        onChange={handleChangeLayOffCurrentApplied}
                      >
                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                        <FormControlLabel value="false" control={<Radio />} label="No" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid direction="column" spacing={2} item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">If yes Please indicate following:</FormLabel>
                    </FormControl>
                    <Item>
                      <TextField
                        label="Number of Canadians"
                        type="number"
                        required
                        variant="outlined"
                        fullWidth
                        disabled={!layOffCurrentApplied}
                        size="small"
                        defaultValue={company.businessDetails[0]?.numOfCanadiansLayOff}
                        inputRef={numOfCandidateCurrentlyAppRef}
                      />
                    </Item>
                    <Item>
                      <TextField
                        label="Foreign Workers"
                        type="number"
                        variant="outlined"
                        fullWidth
                        required
                        size="small"
                        defaultValue={company.businessDetails[0]?.fwCurrentlyApp}
                        disabled={!layOffCurrentApplied}
                        inputRef={fwCurrentlyAppRef}
                      />
                    </Item>
                  </Grid>
                  <Grid direction="column" spacing={2} item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group"></FormLabel>
                    </FormControl>
                    <Item>
                      <TextField
                        label="Reason"
                        disabled={!layOffCurrentApplied}
                        variant="outlined"
                        fullWidth
                        required
                        defaultValue={company.businessDetails[0]?.reasonCurrentlyApp}
                        size="small"
                        inputRef={reasonCurrentlyAppRef}
                      />
                    </Item>
                  </Grid>
                  <Grid spacing={2} item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        Does your company offer Employee Benefit Plan?
                      </FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={banifitPlan}
                        onChange={handleChangeBenifitPlan}
                      >
                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                        <FormControlLabel value="No" control={<Radio />} label="No" />
                        <FormControlLabel value="Not Applicable" control={<Radio />} label="Not Applicable" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid direction="column" spacing={2} item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        If yes; Company offer Employee Benefit Plan :
                      </FormLabel>
                    </FormControl>

                    <Item>
                      <TextField
                        label="Benefit plans"
                        variant="outlined"
                        fullWidth
                        size="small"
                        multiline
                        rows={5}
                        required
                        disabled={banifitPlan != 'Yes'}
                        inputRef={banifitPlanRef}
                        defaultValue={company.businessDetails[0]?.benefitPlans}
                      />
                    </Item>
                  </Grid>
                  <Grid spacing={2} item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        How many working hours per week is for this application?{' '}
                      </FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={workingHours}
                        onChange={handleChangeWorkingHours}
                      >
                        <FormControlLabel value="30" control={<Radio />} label="30 Hours" />
                        <FormControlLabel value="35" control={<Radio />} label="35 Hours" />
                        <FormControlLabel value="37.50" control={<Radio />} label="37.50 Hours" />
                        <FormControlLabel value="40" control={<Radio />} label="40 Hours" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid spacing={2} item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">
                        Does your business receive support through any Government of Canada program (e.g., WorkSharing
                        Program)?
                      </FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={receiveSupport}
                        onChange={handleChangeReceiveSupport}
                      >
                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                        <FormControlLabel value="false" control={<Radio />} label="No" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid direction="column" spacing={2} item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">If yes; Please name the program</FormLabel>
                    </FormControl>
                    <Item>
                      <TextField
                        label="Program"
                        variant="outlined"
                        fullWidth
                        size="small"
                        required
                        disabled={!receiveSupport}
                        defaultValue={company.businessDetails[0]?.governmentOfCanadaProgram}
                        inputRef={programRef}
                      />
                    </Item>
                  </Grid>

                  <Grid spacing={2} item xs={12} sm={4} md={4}>
                    <FormControl>
                      <FormLabel id="demo-controlled-radio-buttons-group">Vacation Pay</FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={vacationPay}
                        onChange={handleChangeVacationPay}
                      >
                        <FormControlLabel value="6" control={<Radio />} label="6%" />
                        <FormControlLabel value="4" control={<Radio />} label="4%" />
                        <FormControlLabel value="15 days" control={<Radio />} label="15 Days" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={4} md={4}>
                    <Button type="submit" variant="contained">
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        )}
      </form>
    </>
  );
};

export default BusinessDetails;
